import { createReducer } from "@reduxjs/toolkit";
import { FilterState, defaultRestrictionState, PermitData } from "../actions/Filters/types";
import { parseDateToPayload, parseShortTimeToPayload } from "../Utilities/dateTimeUtilities";
import {
    getPermitParkingValues,
    getRestrictions,
    getSubRestrictions,
    permitParkingValuesReceived,
    restrictionReceived,
    setGlobalFilters,
    setGlobalFiltersForPFCV,
    setTimeLimitFilter,
    storePermitsData,
    storeSelectedPermitValues,
    storePermitLinksAndSubRestrictionIds,
    storePriceLinksAndSubRestrictionIds,
    subActivityDataReceived,
    subRestrictionReceived,
    timeLimitValuesReceived,
    toggleResetButton,
    storeUserClassCategoryValues,
    storePriceData,
    storeSelectedPriceValues
} from "actions";
import { resetStateRTK } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";

const initialState: FilterState = {
    isRestrictionsFetched: false,
    restrictions: defaultRestrictionState,
    isSubRestrictionsFetched: false,
    subRestrictions: defaultRestrictionState,
    isSubActivityDataFetched: false,
    subActivityData: defaultRestrictionState,
    resetButton: false,
    globalFilters: {
        time: parseShortTimeToPayload(new Date()),
        date: parseDateToPayload(new Date()),
        sub_activity: "all"
    },
    globalFiltersForPFCV: new Set<string>(),
    allGlobalFilters: [],
    timeLimitValues: { time_limit: [] },
    selectedTimeLimit: null,
    isSelectedTimeLimitReceived: false,
    permitParkingValues: defaultRestrictionState,
    selectedPermitValues: null,
    permitLinksAndSubRestrictionIds: { linkIds: [], subRestrictionIds: [], displayNameIds: [] },
    userClassCategoryValues: [],
    permitsData: {},
    priceLinksAndSubRestrictionIds: { linkIds: [], subRestrictionIds: [], displayNameIds: [] },
    priceLimitValues: {},
    selectedPriceValues: null,
    permitsAvailable: true
};

const filters = createReducer(initialState, (builder) => {
    builder
        .addCase(getRestrictions, (state) => {
            state.isRestrictionsFetched = false;
        })
        .addCase(restrictionReceived, (state, action) => {
            state.restrictions = action.payload.data;
            state.isRestrictionsFetched = true;
        })
        .addCase(getSubRestrictions, (state) => {
            state.isSubActivityDataFetched = false;
            state.isSubRestrictionsFetched = false;
        })
        .addCase(subRestrictionReceived, (state, action) => {
            state.subRestrictions = action.payload.data;
            state.isSubRestrictionsFetched = true;
        })
        .addCase(subActivityDataReceived, (state, action) => {
            state.isSubActivityDataFetched = true;
            state.subActivityData = action.payload.data;
            state.isSubRestrictionsFetched = true;
        })
        .addCase(setGlobalFilters, (state, action) => {
            state.globalFilters = action.payload.data[0];
            state.allGlobalFilters = action.payload.data[1];
        })
        .addCase(setGlobalFiltersForPFCV, (state, action) => {
            state.globalFiltersForPFCV = action.payload.data;
        })
        .addCase(toggleResetButton, (state, action) => {
            state.resetButton = action.payload.data;
        })
        .addCase(timeLimitValuesReceived, (state, action) => {
            state.timeLimitValues = action.payload.data;
        })
        .addCase(setTimeLimitFilter, (state, action) => {
            state.isSelectedTimeLimitReceived = action.payload.isSelectedTimeLimitReceived;
            state.selectedTimeLimit = action.payload.data;
        })
        .addCase(permitParkingValuesReceived, (state, action) => {
            state.permitParkingValues = action.payload.data;
            state.permitsAvailable = !!action.payload.data.results.length;
        })
        .addCase(storeSelectedPermitValues, (state, action) => {
            state.selectedPermitValues = action.payload.data;
        })
        .addCase(storePermitLinksAndSubRestrictionIds, (state, action) => {
            state.permitLinksAndSubRestrictionIds = action.payload.data;
        })
        .addCase(storeUserClassCategoryValues, (state, action) => {
            state.userClassCategoryValues = action.payload.data;
        })
        .addCase(storePermitsData, (state, action) => {
            state.permitsData = action.payload.data;
        })
        .addCase(storePriceData, (state, action) => {
            state.priceLimitValues = action.payload.data;
        })
        .addCase(storePriceLinksAndSubRestrictionIds, (state, action) => {
            state.priceLinksAndSubRestrictionIds = action.payload.data;
        })
        .addCase(storeSelectedPriceValues, (state, action) => {
            state.selectedPriceValues = action.payload.data;
        })
        .addCase(resetStateRTK, () => initialState)
        .addDefaultCase((state) => state);
});

export default filters;
